export * from './locales';

import * as _messages from './paraglide/messages.js';

export { baseLocale, getLocale, locales, setLocale } from './paraglide/runtime.js';

export const m = new Proxy(_messages, {
  get(target, prop, receiver) {
    if (prop in target) {
      return Reflect.get(target, prop, receiver);
    }

    if (typeof prop === 'string') {
      console.warn(`[i18n] Missing message: "${prop}"`);
      return () => prop;
    }

    return undefined;
  },
}) as typeof _messages & Record<string, () => string>;
